// extracted by mini-css-extract-plugin
export default {"content":"vG","wrapper":"wG","gif":"xG","textContent":"yG","gifContainer":"zG","proteinGif":"AG","counter_img":"BG","usage-container":"CG","usage-list":"EG","checklist":"FG","counter_title":"GG","counter_wrapper":"HG","active":"IG","usage-counter":"JG","line":"KG"};
    if(module.hot) {
      // 1713211521041
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  